import axios from ".";
import qs from "qs";
/** List requests with support for repeated query params. */
export const getRequest = (params: any) => {
  return axios({
    method: "GET",
    url: "/requests",
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }), // ✅ this makes status=pending&status=approved
    headers: {
      //"Authorization": `Bearer ${token}`,
      //"x-source-module": moduleName,
    },
  });
};

/** Update a request's approval status. */
export const updateRequestStatus = (
  titleId: number,
  status: "Approved" | "Rejected",
) => {
  return axios({
    method: "PATCH",
    url: "/requests/update-status",
    data: {
      titleId,
      status,
    },
    headers: {
      //"Authorization": `Bearer ${token}`,
      //"x-source-module": moduleName,
    },
  });
};

/** Fetch a single request including its comments by id. */
export const getRequestCommentsById = (id: any) => {
  return axios({
    method: "GET",
    url: `/requests/${id}`,
  });
};

/** Add a comment to a request thread. */
export const addRequestComment = (data: any) => {
  return axios({
    method: "POST",
    url: `/requests`,
    data: data,
  });
};
